import type { CmmdForgeAutomationRunDetail } from "@cmmd-forge/contracts";
import { BanIcon, CheckIcon, RefreshCwIcon, RotateCcwIcon, SquareIcon } from "lucide-react";

import { Button } from "~/components/ui/button";
import { cn } from "~/lib/utils";

export type ForgeAutomationRunAction = "retry" | "cancel" | "approve" | "reject";

export interface ForgeAutomationRunActionsProps {
  readonly status: CmmdForgeAutomationRunDetail["run"]["status"];
  readonly loading: boolean;
  readonly busyAction: ForgeAutomationRunAction | null;
  readonly onRefresh: () => void;
  readonly onRetry: () => void;
  readonly onCancel: () => void;
  readonly onApprove: () => void;
  readonly onReject: () => void;
}

export function ForgeAutomationRunActions(props: ForgeAutomationRunActionsProps) {
  const canRetry =
    props.status === "failed" || props.status === "blocked" || props.status === "cancelled";
  const canCancel = props.status === "queued" || props.status === "running";
  const needsReview = props.status === "needs_review";

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      {canRetry ? (
        <Button size="sm" disabled={props.busyAction !== null} onClick={props.onRetry}>
          <RotateCcwIcon className="size-3.5" />
          Retry
        </Button>
      ) : null}
      {canCancel ? (
        <Button
          size="sm"
          variant="outline"
          disabled={props.busyAction !== null}
          onClick={props.onCancel}
        >
          <SquareIcon className="size-3.5" />
          Cancel run
        </Button>
      ) : null}
      {needsReview ? (
        <>
          <Button size="sm" disabled={props.busyAction !== null} onClick={props.onApprove}>
            <CheckIcon className="size-3.5" />
            Approve
          </Button>
          <Button
            size="sm"
            variant="outline"
            disabled={props.busyAction !== null}
            onClick={props.onReject}
          >
            <BanIcon className="size-3.5" />
            Block
          </Button>
        </>
      ) : null}
      <Button
        size="sm"
        variant="ghost"
        disabled={props.loading || props.busyAction !== null}
        onClick={props.onRefresh}
      >
        <RefreshCwIcon className={cn("size-3.5", props.loading ? "animate-spin" : null)} />
        Refresh
      </Button>
    </div>
  );
}
